import {
  GET_PIMADATA,
  GET_PIMADATA_JAN_2021,
  GET_PIMADATA_FEB_2021,
  GET_PIMADATA_DEC_2020,
  GET_PIMADATA_NOV_2020,
  GET_PIMADATA_OCT_2020,
  GET_PIMADATA_SEP_2020,
  GET_PIMADATA_AGO_2020,
  GET_PIMADATA_JUL_2020,
  GET_PIMADATA_JUN_2020,
  GET_PIMADATA_MAY_2020,
  GET_PIMADATA_APR_2020,
  GET_PIMADATA_MAR_2020,
  GET_PIMADATA_AGO_2021,
  GET_PIMADATA_APR_2021,
  GET_PIMADATA_DEC_2021,
  GET_PIMADATA_JUL_2021,
  GET_PIMADATA_JUN_2021,
  GET_PIMADATA_MAR_2021,
  GET_PIMADATA_MAY_2021,
  GET_PIMADATA_NOV_2021,
  GET_PIMADATA_OCT_2021,
  GET_PIMADATA_SEP_2021,
} from "../actions/types";

const initialState = {
  pimadatas: [],
  pddec2021: [],
  pdnov2021: [],
  pdoct2021: [],
  pdsep2021: [],
  pdago2021: [],
  pdjul2021: [],
  pdjun2021: [],
  pdmay2021: [],
  pdapr2021: [],
  pdmar2021: [],
  pdfeb2021: [],
  pdjan2021: [],
  pddec2020: [],
  pdnov2020: [],
  pdoct2020: [],
  pdsep2020: [],
  pdago2020: [],
  pdjul2020: [],
  pdjun2020: [],
  pdmay2020: [],
  pdapr2020: [],
  pdmar2020: [],
};
// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PIMADATA:
      return {
        ...state,
        pimadatas: payload,
      };
    case GET_PIMADATA_DEC_2021:
      return {
        ...state,
        pddec2021: payload,
      };
    case GET_PIMADATA_NOV_2021:
      return {
        ...state,
        pdnov2021: payload,
      };
    case GET_PIMADATA_OCT_2021:
      return {
        ...state,
        pdoct2021: payload,
      };
    case GET_PIMADATA_SEP_2021:
      return {
        ...state,
        pdsep2021: payload,
      };
    case GET_PIMADATA_AGO_2021:
      return {
        ...state,
        pdago2021: payload,
      };
    case GET_PIMADATA_JUL_2021:
      return {
        ...state,
        pdjul2021: payload,
      };
    case GET_PIMADATA_JUN_2021:
      return {
        ...state,
        pdjun2021: payload,
      };
    case GET_PIMADATA_MAY_2021:
      return {
        ...state,
        pdmay2021: payload,
      };
    case GET_PIMADATA_APR_2021:
      return {
        ...state,
        pdapr2021: payload,
      };
    case GET_PIMADATA_MAR_2021:
      return {
        ...state,
        pdmar2021: payload,
      };
    case GET_PIMADATA_FEB_2021:
      return {
        ...state,
        pdfeb2021: payload,
      };
    case GET_PIMADATA_JAN_2021:
      return {
        ...state,
        pdjan2021: payload,
      };
    case GET_PIMADATA_DEC_2020:
      return {
        ...state,
        pddec2020: payload,
      };
    case GET_PIMADATA_NOV_2020:
      return {
        ...state,
        pdnov2020: payload,
      };
    case GET_PIMADATA_OCT_2020:
      return {
        ...state,
        pdoct2020: payload,
      };
    case GET_PIMADATA_SEP_2020:
      return {
        ...state,
        pdsep2020: payload,
      };
    case GET_PIMADATA_AGO_2020:
      return {
        ...state,
        pdago2020: payload,
      };
    case GET_PIMADATA_JUL_2020:
      return {
        ...state,
        pdjul2020: payload,
      };
    case GET_PIMADATA_JUN_2020:
      return {
        ...state,
        pdjun2020: payload,
      };
    case GET_PIMADATA_MAY_2020:
      return {
        ...state,
        pdmay2020: payload,
      };
    case GET_PIMADATA_APR_2020:
      return {
        ...state,
        pdapr2020: payload,
      };
    case GET_PIMADATA_MAR_2020:
      return {
        ...state,
        pdmar2020: payload,
      };
    default:
      return state;
  }
}
